import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children"];
import React, { forwardRef } from 'react';
import Tab from '.';
var FixedHeightTab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/React.createElement(Tab, _extends({}, otherProps, {
    as: Component,
    ref: ref,
    height: 56
  }), children);
});
FixedHeightTab.displayName = 'FixedHeightTab';
export default FixedHeightTab;